import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { useNavigate, useParams } from 'react-router-dom';

const ViewSupplier = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSupplier = async () => {
      try {
        const response = await api.get(`/suppliers/${id}`);
        setSupplier(response.data);
      } catch (err) {
        console.error('Error fetching supplier:', err);
        setError('Failed to load supplier details.');
      } finally {
        setLoading(false);
      }
    };
    fetchSupplier();
  }, [id]);

  if (loading) return <div className="container mt-4"><p>Loading supplier details...</p></div>;
  if (error)   return <div className="container mt-4"><p className="text-danger">{error}</p></div>;
  if (!supplier) return null;

  const mainFields = [
    { label: 'Supplier Name',      value: supplier.supplier_name },
    { label: 'Email',              value: supplier.email },
    { label: 'Phone',              value: supplier.phone },
    { label: 'Branch',             value: supplier.branch },
    { label: 'Relationship Staff', value: supplier.relationship_staff },
    { label: 'Address',            value: supplier.address },
    { label: 'TRN Number',         value: supplier.trn_number },
    { label: 'Opening Balance',    value: supplier.opening_balance !== undefined ? `${supplier.opening_balance}` : undefined },
  ];

  const contactPersons = supplier.contact_persons || [];

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>🏢 Supplier Details</h2>
        <div className="d-flex gap-2">
          <button
            className="btn btn-warning"
            onClick={() => navigate(`/dashboard/suppliers/edit/${id}`)}
          >
            ✏️ Edit Supplier
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/dashboard/suppliers/list')}
          >
            ← Back to List
          </button>
        </div>
      </div>

      <div className="card shadow-sm mb-4">
        <div className="card-header fw-bold">General Information</div>
        <div className="card-body">
          <table className="table table-borderless mb-0">
            <tbody>
              {mainFields.map((f, i) =>
                f.value ? (
                  <tr key={i}>
                    <th style={{ width: '200px', color: '#555' }}>{f.label}</th>
                    <td>{f.value}</td>
                  </tr>
                ) : null
              )}
            </tbody>
          </table>
        </div>
      </div>

      {contactPersons.length > 0 && (
        <div className="card shadow-sm">
          <div className="card-header fw-bold">Contact Persons</div>
          <div className="card-body p-0">
            <table className="table table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {contactPersons.map((cp, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{cp.name || '—'}</td>
                    <td>{cp.number || '—'}</td>
                    <td>{cp.email || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewSupplier;
